import { render } from "./Advertise.vue?vue&type=template&id=040b01d9&scoped=true"
import script from "./Advertise.vue?vue&type=script&lang=js"
export * from "./Advertise.vue?vue&type=script&lang=js"

import "./Advertise.vue?vue&type=style&index=0&id=040b01d9&lang=less&scoped=true"

import exportComponent from "/home/data/jenkins/workspace/Pro_TWI_T/Pro_TWI_h5_advantrade-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-040b01d9"]])

export default __exports__